import { PhoneNumberFormat, PhoneNumberUtil } from "google-libphonenumber";

const phoneUtil = PhoneNumberUtil.getInstance();

export const getRegionCode = (phoneNumber) => {
  const regionCode = phoneUtil.getRegionCodeForNumber(
    phoneUtil.parse(phoneNumber, "")
  );

  return regionCode;
};

export const formatPhoneNumber = (phoneNumber) => {
  const regionCode = getRegionCode(phoneNumber);

  if (regionCode) {
    return phoneUtil.format(
      phoneUtil.parse(phoneNumber, regionCode),
      PhoneNumberFormat.INTERNATIONAL
    );
  }

  return phoneNumber;
};

export const validatePhoneNumber = (phoneNumber) => {
  const regionCode = getRegionCode(phoneNumber);

  return phoneUtil.isValidNumberForRegion(
    phoneUtil.parse(phoneNumber, regionCode),
    regionCode
  );
};
